import React, { Component, useState, useEffect, } from "react";
import SyncLoader  from "react-spinners/SyncLoader";
import NewsCard from "./HomeComp/newsCard";
import Tiers from "./HomeComp/tiers"
import AboutUs from "./HomeComp/aboutUs";
import AlertReq from "./HomeComp/alertReq";
import UpComingProject from "./HomeComp/upComingProject";
import PreviousProject from "./HomeComp/previousProject";
import FAQ from "./HomeComp/faq";

function Home() {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true) 
        setTimeout(() => {
            setLoading(false)
        }, 3000)
    }, [])

    return (
        <React.Fragment>

            {loading ? 
             
             <div className="animation_widget">
                 <SyncLoader 
                 loading={loading}
                 size={30} 
                 color = {"yellow"}
                  />
             </div>

             :
             
             <div>
                {/* <NewsCard /> */}
                <Tiers />
                <AboutUs />
                <AlertReq />
                <UpComingProject />
                <PreviousProject />
                <FAQ />
             </div>
            

            }
        </React.Fragment>
    );
}

export default Home;